<template>
  <div class="confirm-module-price-text">
    <base-price-text
      :price="price"
      :styleOption="{
        currency: 'font-size: 14px;line-height:16px;margin-right: 2px;',
        integer: 'font-size: 20px;line-height:19px;',
        decimal: 'font-size: 16px;',
      }"
    >
      <template #right><span
          style="font-size: 12px;line-height:16px;margin-left: 4px;font-weight: 400;"
        >/人</span><span
          style="color: #5F666E;font-size: 12px;line-height:16px;margin-left: 4px;font-weight: 400;"
        > x {{length}}</span></template>
    </base-price-text>
  </div>
</template>

<script>
import BasePriceText from './base-price-text.vue';

export default {
  components: {
    BasePriceText,
  },
  props: {
    price: Number,
    length: Number,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.confirm-module-price-text{
  color: #FF8033;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/base/confirm-module-price-text.vue